import camelcaseKeys from 'camelcase-keys'
import qsStringify from 'qs/lib/stringify'
import {
  UnauthorizedError,
  ValidationError,
  BadRequestError,
  ServiceUnavailableError,
  InternalServerError
} from './errors'

export const paramsSerializer = (params) => qsStringify(params, { arrayFormat: 'comma' })

export const camelCaseTransformer = (data) => {
  if (data && typeof data === 'object') {
    try {
      data = camelcaseKeys(data, { deep: true })
    } catch (e) { }
  }
  return data
}

export async function errorHandlingInterceptor (error) {
  if (error.response) {
    const { response: { status, data = {} } } = error

    switch (status) {
      case 400:
        if (data.errors) throw new BadRequestError({ errors: data.errors })
        break
      case 401:
        throw new UnauthorizedError()
      case 422:
        if (data.errors) throw new ValidationError({ errors: data.errors })
        break
      case 500:
        throw new InternalServerError()
      case 503:
        throw new ServiceUnavailableError()
    }
  }

  return Promise.reject(error)
}
